import { opacityHex } from '../utils/color.utils';

/** Figma Transparent shadow base — rgba(23, 23, 44, *) */
const shadowColor = '#17172C';

const shadowRgba = (opacityPercent: number) =>
    opacityHex(shadowColor, opacityPercent);

const layer = (offsetY: number, blur: number, opacityPercent: number) =>
    `0px ${offsetY}px ${blur}px 0px ${shadowRgba(opacityPercent)}`;

/**
 * Elevation shadows from Figma Shadow/10–50, plus Shadow/Hover/10–50.
 * Access: `vars.shadow['30']` / `vars.shadow.hover['30']`
 */
const shadow = {
    '10': `${layer(1, 2, 10)}, ${layer(0, 4, 5)}`,
    '20': `${layer(1, 4, 10)}, ${layer(8, 12, 5)}`,
    '30': `${layer(0, 4, 5)}, ${layer(8, 16, 5)}, ${layer(12, 24, 5)}`,
    '40': `${layer(1, 4, 5)}, ${layer(8, 16, 5)}, ${layer(16, 32, 10)}`,
    '50': `${layer(2, 4, 10)}, ${layer(8, 16, 10)}, ${layer(16, 32, 20)}`,
    hover: {
        '10': `${layer(1, 2, 10)}, ${layer(0, 4, 10)}`,
        '20': `${layer(1, 4, 10)}, ${layer(8, 12, 10)}`,
        '30': `${layer(0, 4, 5)}, ${layer(8, 16, 10)}, ${layer(12, 24, 10)}`,
        '40': `${layer(1, 4, 5)}, ${layer(8, 16, 10)}, ${layer(16, 32, 20)}`,
        '50': `${layer(2, 4, 10)}, ${layer(8, 16, 20)}, ${layer(16, 32, 30)}`
    }
} as const;

export default shadow;
